import { Cart } from 'store/api/cart';
import { capitalize } from 'utils/string';
import { formatPrice } from 'utils/helpers';
import { EventCheckout } from 'store/api/event';
import { CloverPayment, PaymentMethod, PaymentMethodType } from 'types';

export const getPaymentMethodTypes = (data?: EventCheckout) => {
  const paymentMethodTypes = data?.paymentMethods?.map(
    (method) =>
      `${capitalize(method.type)} (${formatPrice(method.totalAmount)})`
  );

  const creditMethods = data?.paymentMethods?.filter(
    (method) => method.type === PaymentMethodType.Credit
  );

  return {
    paymentMethodTypes,
    isCredit: !!creditMethods?.length,
    creditMethods: data?.cloverPayments?.length
      ? data.cloverPayments
      : creditMethods,
  };
};

export const isPaymentMethod = (
  method: PaymentMethod | CloverPayment
): method is PaymentMethod => (method as PaymentMethod).last4CC !== undefined;

export const getCartDataFromCheckout = (checkout?: EventCheckout): Cart =>
  ({
    user: checkout?.user,
    event: checkout?.event,
    userId: checkout?.userId,
    eventId: checkout?.eventId,
    items: checkout?.items?.map((item) => ({
      id: item.id,
      cost: item.cost,
      price: item.price,
      notes: item.notes,
      product: item.product,
      quantity: item.quantity,
      productId: item.productId,
      isDamaged: item.isDamaged,
      isExchange: item.isExchange,
      isShipping: item.isShipping,
      priceApproval: item.priceApproval,
      priceApprovalId: item.priceApprovalId,
      isProductOutStorage: item.isProductOutStorage,
    })),
  }) as Cart;
